<template>
  <Cms :pageTitle="'Conteúdo da Página Institucional'" :pageName="'about'"></Cms>
</template>
<script>
import Cms from '@/pages/cms/Cms'
export default {
  name: 'AboutCms',
  components: {Cms}
}
</script>



// WEBPACK FOOTER //
// AboutCms.vue?f28f4950